import { useIntl } from "react-intl";
import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';
import { BudgetDTO } from "../../dto/budget/BudgetDTO";
import { duplicateBudget } from "../../servicesHooks/Budget/useBudgetService"; 
import { useState } from "react";
import { setNotification, ETypeOfNotification } from "medere-ui-framework";

interface UpdateBudgetModalProps {
  openUpdateBudgetModal: boolean;
  setOpenUpdateBudgetModal: (open: boolean) => void;
  updateBudget: (updateConfirmed: boolean) => void;
  editMode: boolean;
}

export default function UpdateBudgetModal({
  openUpdateBudgetModal,
  setOpenUpdateBudgetModal,
  updateBudget,
}: UpdateBudgetModalProps) {
  const intl = useIntl();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleUpdate = (updateConfirmed: boolean) => {
    if (isProcessing) return; 
    setIsProcessing(true);
    updateBudget(updateConfirmed); 
    setIsProcessing(false);
};

  return (
    <Modal
      visible={openUpdateBudgetModal}
      setVisible={setOpenUpdateBudgetModal}
      className="nv-scope nv-dialog custom-modal w-auto"
      header={
        <span className="nv-modal-title">
          {intl.formatMessage({ id: "update_prices_title", defaultMessage: "Modificar Convenio/Plan" })}
        </span>
      }
      footerButtonRightText={intl.formatMessage({ id: "update_prices_yes", defaultMessage: "Si, actualizar" })}
      footerButtonLeftText={intl.formatMessage({ id: "update_prices_no", defaultMessage: "No, cancelar" })}
      onClickLeftBtn={() => handleUpdate(false)}
      onClickRightBtn={() => handleUpdate(true)}
      closable={!isProcessing}
    >
      <div>
        <p>
          {intl.formatMessage({
            id: "update_prices_message",
            defaultMessage: "Al modificar un plan o convenio los valores del presupuestos se actualizarán.  ¿Querés actualizarlo?",
          })}
        </p>
        {isProcessing && <p>{intl.formatMessage({ id: "Processing", defaultMessage: "Procesando..." })}</p>}
      </div>
    </Modal>
  );
}